import { render } from "./GridShareAppointments.vue?vue&type=template&id=1fbc2fa0&scoped=true&ts=true"
import script from "./GridShareAppointments.vue?vue&type=script&lang=ts"
export * from "./GridShareAppointments.vue?vue&type=script&lang=ts"

import "./GridShareAppointments.vue?vue&type=style&index=0&id=1fbc2fa0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fbc2fa0"]])

export default __exports__